<template>
  <svg
    width="23"
    height="27"
    viewBox="0 0 23 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_40002730_3675"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="23"
      height="27"
    >
      <path
        d="M21.1397 26.0332H1.86029C0.832882 26.0332 0 25.2017 0 24.1761V1.89035C0 0.864675 0.832882 0.0332031 1.86029 0.0332031H14.375L23 8.64359V24.1761C23 25.2017 22.1671 26.0332 21.1397 26.0332Z"
        fill="url(#paint0_linear_40002730_3675)"
      />
    </mask>
    <g mask="url(#mask0_40002730_3675)">
      <path
        d="M21.1397 26.0332H1.86029C0.832882 26.0332 0 25.2017 0 24.1761V1.89035C0 0.864675 0.832882 0.0332031 1.86029 0.0332031H14.375L23 8.64359V24.1761C23 25.2017 22.1671 26.0332 21.1397 26.0332Z"
        fill="url(#paint1_linear_40002730_3675)"
      />
      <path
        d="M5.08738 15.3534H8.73538V16.3374H6.27138V17.8814H8.37538V18.8734H6.27138V21.2734H5.08738V15.3534ZM9.67106 16.7934H10.8391V21.2734H9.67106V16.7934ZM10.2631 16.0734C10.0604 16.0734 9.8924 16.0148 9.75906 15.8974C9.62573 15.7748 9.55906 15.6201 9.55906 15.4334C9.55906 15.2414 9.62573 15.0868 9.75906 14.9694C9.8924 14.8521 10.0604 14.7934 10.2631 14.7934C10.4657 14.7934 10.6311 14.8521 10.7591 14.9694C10.8924 15.0868 10.9591 15.2414 10.9591 15.4334C10.9591 15.6201 10.8924 15.7748 10.7591 15.8974C10.6311 16.0148 10.4657 16.0734 10.2631 16.0734ZM12.1008 21.2734V14.8894H13.2688V21.2734H12.1008ZM16.5682 21.3854C16.2535 21.3854 15.9602 21.3321 15.6882 21.2254C15.4215 21.1188 15.1869 20.9668 14.9842 20.7694C14.7869 20.5668 14.6295 20.3214 14.5122 20.0334C14.4002 19.7401 14.3442 19.4094 14.3442 19.0414C14.3442 18.6788 14.4029 18.3534 14.5202 18.0654C14.6375 17.7721 14.7922 17.5241 14.9842 17.3214C15.1815 17.1134 15.4055 16.9561 15.6562 16.8494C15.9069 16.7374 16.1655 16.6814 16.4322 16.6814C16.7415 16.6814 17.0109 16.7348 17.2402 16.8414C17.4749 16.9481 17.6695 17.0974 17.8242 17.2894C17.9842 17.4814 18.1042 17.7081 18.1842 17.9694C18.2642 18.2308 18.3042 18.5161 18.3042 18.8254C18.3042 18.9321 18.2989 19.0361 18.2882 19.1374C18.2775 19.2334 18.2642 19.3081 18.2482 19.3614H15.4882C15.5362 19.7294 15.6695 20.0094 15.8882 20.2014C16.1122 20.3881 16.3922 20.4814 16.7282 20.4814C16.9149 20.4814 17.0882 20.4548 17.2482 20.4014C17.4135 20.3481 17.5762 20.2708 17.7362 20.1694L18.1362 20.8894C17.9122 21.0441 17.6642 21.1668 17.3922 21.2574C17.1255 21.3428 16.8509 21.3854 16.5682 21.3854ZM17.2962 18.5854C17.2962 18.2814 17.2269 18.0414 17.0882 17.8654C16.9495 17.6841 16.7362 17.5934 16.4482 17.5934C16.2135 17.5934 16.0029 17.6788 15.8162 17.8494C15.6295 18.0148 15.5149 18.2601 15.4722 18.5854H17.2962Z"
        fill="white"
      />
      <g filter="url(#filter0_d_40002730_3675)">
        <path
          d="M23 8.64359H16.375C15.2704 8.64359 14.375 7.74816 14.375 6.64359V0.0332031L23 8.64359Z"
          fill="url(#paint2_linear_40002730_3675)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_40002730_3675"
        x="-8.625"
        y="-23.9668"
        width="58.625"
        height="58.6104"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx="2"
          dy="1"
        />
        <feGaussianBlur stdDeviation="12.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_40002730_3675"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_40002730_3675"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_40002730_3675"
        x1="11.5"
        y1="0.0332031"
        x2="11.5"
        y2="26.0332"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF7979" />
        <stop
          offset="1"
          stop-color="#E85555"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_40002730_3675"
        x1="11.5"
        y1="0.0332031"
        x2="11.5"
        y2="26.0332"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE284" />
        <stop
          offset="1"
          stop-color="#F0B800"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_40002730_3675"
        x1="18.6875"
        y1="0.0332031"
        x2="18.6875"
        y2="8.64359"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFCA1B" />
        <stop
          offset="1"
          stop-color="#D1A513"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
